import { CHAINID, isDevelopment } from "../utils/env";
import { useWeb3Context } from "./web3Context";
import { useCallback } from "react";
export var useEVMWeb3Context = function () {
    var providers = {
        mainnet: useWeb3Context(isDevelopment() ? CHAINID.ETH_KOVAN : CHAINID.ETH_MAINNET).provider,
        avax: useWeb3Context(isDevelopment() ? CHAINID.AVAX_FUJI : CHAINID.AVAX_MAINNET).provider,
        bsc: useWeb3Context(CHAINID.BINANCE_MAINNET).provider,
    };
    var getProviderForNetwork = useCallback(function (network) { return providers[network]; }, [providers.mainnet, providers.avax] // eslint-disable-line react-hooks/exhaustive-deps
    );
    return {
        getProviderForNetwork: getProviderForNetwork,
    };
};
//# sourceMappingURL=useEVMWeb3Context.js.map